<template>
  <div class="ps-update-page">
    <a-spin :spinning="pageLoading">
      <div class="ps-form-layout">
        <aside class="ps-sidebar">
          <div class="ps-side-card">
            <div class="ps-side-title">填写步骤</div>
            <button
              v-for="(mod, i) in modules"
              :key="mod.key"
              type="button"
              class="ps-step-item"
              :class="{ active: i === editStep, 'has-change': moduleChanged(mod.key) }"
              @click="editGo(i)"
            >
              <span class="ps-step-label">
                {{ mod.label }}
              </span>
              <span class="ps-step-mark">{{ i === editStep ? "✎" : moduleChanged(mod.key) ? moduleTotal(mod.key) : "" }}</span>
            </button>
            <div class="ps-side-hint">
              点击步骤切换模块，带 <b style="color: #ef4444">*</b> 的为必填项
            </div>
          </div>
        </aside>

        <div class="ps-content">
          <div class="ps-status-bar">
            <div class="ps-status-block">
              <span class="ps-status-label">当前状态</span>
              <StatusBadge :status="project.auditState" />
            </div>
            <div class="ps-status-block">
              <span class="ps-status-label">正在编辑</span>
              <span class="ps-status-value warn">{{ editingStatusText }}</span>
            </div>
            <div
              v-if="baseChangeDiffs.length"
              class="ps-status-block ps-status-block--click"
              @click="goModule('GZSJIBENXINXI')"
            >
              <span class="ps-status-label">工作室基本信息</span>
              <span class="ps-status-value warn">
                {{ baseChangeDiffs.length }} 处{{ baseLocked ? "待审核" : "草稿" }}变更
              </span>
            </div>
            <div style="flex: 1"></div>
            <button type="button" class="ps-btn ps-btn--white" :disabled="saving" @click="saveDraft">
              💾 保存草稿
            </button>
            <button type="button" class="ps-btn ps-btn--blue" :disabled="saving" @click="submitAudit">
              ✉ 提交变更审核
            </button>
            <!-- <button type="button" class="ps-btn ps-btn--outline-orange" @click="openCompare">
              ⇄ 对比上一版
            </button> -->
            <button type="button" class="ps-btn ps-btn--white" @click="goBack">↩ 返回</button>
          </div>

          <div class="ps-form-card" :class="{ 'is-origin-form': currentKey === 'GZSJIBENXINXI' }">
            <div v-show="currentKey === 'GZSJIBENXINXI'" class="card-item origin-base-form">
              <div class="title-box">
                <span class="title-text">{{ currentModule.label }}</span>
                <span class="ps-form-hint">⚠ 已从当前已通过版本自动复制，绿色为本次变更项</span>
              </div>
              <div v-if="baseLocked" class="ps-lock-banner">
                基本信息已提交审核，当前不可修改。请先撤销后再编辑。
                <button
                  type="button"
                  class="ps-btn ps-btn--outline-orange"
                  :disabled="saving"
                  @click="cancelPendingTask"
                >
                  撤销待审核
                </button>
              </div>
              <div v-if="baseChangeDiffs.length" class="ps-draft-panel">
                <div class="ps-draft-panel__title">
                  {{ baseLocked ? "待审核中的基本信息变更" : "本次基本信息草稿变更" }}
                  · {{ baseChangeDiffs.length }} 项
                </div>
                <div
                  v-for="(f, i) in baseChangeDiffs"
                  :key="'bd' + i"
                  class="ps-draft-panel__row"
                >
                  <span class="k">{{ f.name }}</span>
                  <span class="diff-old">{{ f.old }}</span>
                  <span class="ps-preview-arrow">→</span>
                  <span class="diff-new">{{ f.new }}</span>
                </div>
              </div>
              <div class="ps-form-fields" :class="{ 'ps-readonly': baseLocked }">
                <div class="mt30">
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('name') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 工作室名称
                    </div>
                    <div class="pl16">
                      <a-input
                        class="input-style-2"
                        placeholder="请输入工作室名称"
                        :maxLength="100"
                        v-model="form.name"
                      />
                    </div>
                  </div>
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('applyYear') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 申报年份
                    </div>
                    <div class="pl16">
                      <a-date-picker
                        placeholder="请选择申报年份"
                        v-model="form.applyYear"
                        :open="yearOpen.applyYear"
                        :locale="locale"
                        format="YYYY"
                        mode="year"
                        class="form-item-right"
                        @openChange="(s) => (yearOpen.applyYear = s)"
                        @panelChange="(v) => onYearChange('applyYear', v)"
                      />
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div class="form-item" style="width: 100%" :class="{ 'is-changed': isBaseChanged('address') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 工作室地点
                    </div>
                    <div class="pl16">
                      <a-input
                        class="input-style-2"
                        :maxLength="50"
                        placeholder="请输入工作室地点"
                        v-model="form.address"
                      />
                    </div>
                  </div>
                 
                </div>
                <div class="mt30">
                   <div class="form-item" :class="{ 'is-changed': isBaseChanged('acreage') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 场所面积
                    </div>
                    <div class="pl16 plflex">
                      <a-input
                        class="input-style-2"
                        placeholder="请输入场所面积"
                        v-model="form.acreage"
                        style="width: 86%"
                      />
                      <span class="text2">平米</span>
                    </div>
                  </div>
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('foundTime') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 建设日期
                    </div>
                    <div class="pl16">
                      <a-date-picker
                        placeholder="请选择建设日期"
                        v-model="form.foundTime"
                        :locale="locale"
                        format="YYYY-MM-DD"
                        class="form-item-right"
                      />
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div class="form-item" style="width: 100%" :class="{ 'is-changed': isBaseChanged('belongDepartment') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 所属部门
                    </div>
                    <div class="pl16">
                      <a-input
                        class="input-style-2"
                        :maxLength="100"
                        placeholder="请输入所属部门"
                        v-model="form.belongDepartment"
                      />
                    </div>
                  </div> 
                </div>
                <div class="mt30">
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('tsSzgzsKnow') }">
                    <div class="main-text-style">全校师生对工作室知晓度</div>
                    <div class="pl16 flex align-items-center">
                      <a-input-number v-model="form.tsSzgzsKnow" :precision="0" class="percentage-text" />
                      <span class="text2">%</span>
                    </div>
                  </div>
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('tsSzgzsSatisfied') }">
                    <div class="main-text-style">全校师生对工作室服务满意度</div>
                    <div class="pl16 flex align-items-center">
                      <a-input-number
                        v-model="form.tsSzgzsSatisfied"
                        :precision="0"
                        class="percentage-text"
                      />
                      <span class="text2">%</span>
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('reportNum') }">
                    <div class="main-text-style">项目被省级或国家级媒体报道次数</div>
                    <div class="pl16 flex align-items-center">
                      <a-input-number v-model="form.reportNum" :precision="0" class="percentage-text" />
                      <span class="percentage-sign" @click="showEvidence(0)">佐证</span>
                    </div>
                  </div>
                  <div class="form-item" :class="{ 'is-changed': isBaseChanged('conmunicateNum') }">
                    <div class="main-text-style">省内外同类院校前来交流学习次数</div>
                    <div class="pl16 flex align-items-center">
                      <a-input-number
                        v-model="form.conmunicateNum"
                        :precision="0"
                        class="percentage-text"
                      />
                      <span class="percentage-sign" @click="showEvidence(1)">佐证</span>
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div class="form-item-upload" :class="{ 'is-changed': isBaseChanged('studioStatus') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 工作室运行状态
                    </div>
                    <div class="pl16">
                      <a-switch
                        checked-children="开"
                        un-checked-children="关"
                        v-model="form.studioStatus"
                      />
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div class="form-item-upload" :class="{ 'is-changed': isFileChanged('declarationName') }">
                    <div class="main-text-style">
                      <span style="color: #f6350f">*</span> 申报书上传
                    </div>
                    <div class="pl16">
                      <a-upload
                        :file-list="fileList"
                        accept=".pdf"
                        :disabled="baseLocked"
                        :remove="baseLocked ? () => false : () => removeFile('declaration')"
                        :before-upload="(f) => beforeUpload(f, 'declaration')"
                      >
                        <a-button :disabled="baseLocked || loadingDecl">
                          <a-icon type="upload" />上传附件
                        </a-button>
                        <span class="text2">注：请上传pdf格式的文件</span>
                      </a-upload>
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div class="form-item-upload" :class="{ 'is-changed': isFileChanged('activityPlanName') }">
                    <div class="main-text-style">建设方案上传</div>
                    <div class="pl16">
                      <a-upload
                        :file-list="planList"
                        accept=".pdf"
                        :disabled="baseLocked"
                        :remove="baseLocked ? () => false : () => removeFile('plan')"
                        :before-upload="(f) => beforeUpload(f, 'plan')"
                      >
                        <a-button :disabled="baseLocked || loadingPlan">
                          <a-icon type="upload" />上传附件
                        </a-button>
                        <span class="text2">注：请上传pdf格式的文件</span>
                      </a-upload>
                    </div>
                  </div>
                </div>
                <div class="mt30">
                  <div
                    class="form-item-upload"
                    :class="{ 'is-changed': isFileChanged('letterOfCommitmentName') }"
                  >
                    <div class="main-text-style">校方承诺书上传</div>
                    <div class="pl16">
                      <a-upload
                        :file-list="letterList"
                        accept=".pdf"
                        :disabled="baseLocked"
                        :remove="baseLocked ? () => false : () => removeFile('letter')"
                        :before-upload="(f) => beforeUpload(f, 'letter')"
                      >
                        <a-button :disabled="baseLocked || loadingLetter">
                          <a-icon type="upload" />上传附件
                        </a-button>
                        <span class="text2">注：请上传pdf格式的文件</span>
                      </a-upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="currentKey === 'GZSTUANDUI'" class="ps-list-embed">
              <team-info
                v-if="project.id"
                :old-infos="editInfo"
                :show-change-status="true"
                :isbj="false"
                card-title="工作室团队"
              />
            </div>
            <div v-show="currentKey === 'GZSJIAOYANQINGKUANG'" class="ps-list-embed">
              <teach-add v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSZIJINYUSUAN'" class="ps-list-embed">
              <budget
                v-if="project.id"
                :old-infos="editInfo"
                :show-change-status="true"
                :isbj="false"
                card-title="工作室资金预算"
              />
            </div>
            <div v-show="currentKey === 'GZSZIJINZICHU'" class="ps-list-embed">
              <capital-expenditure
                v-if="project.id"
                :old-infos="editInfo"
                :show-change-status="true"
                :isbj="false"
                card-title="工作室资金支出"
              />
            </div>
            <div v-show="currentKey === 'GZSKEYANQINGKUANG'" class="ps-list-embed">
              <scientifice-add v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSHUODONGFANGAN'" class="ps-list-embed">
              <activity-plan v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSBIAOZHIXINGCHENGGUO'" class="ps-list-embed">
              <result-mod v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSKCZSSZKC'" class="ps-list-embed">
              <activity-mod v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSTUANDUIJIANSHE'" class="ps-list-embed">
              <team-building v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSSHIJIANJIDI'" class="ps-list-embed">
              <practice-base v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'GZSRONGYU'" class="ps-list-embed">
              <honor v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
            <div v-show="currentKey === 'PEIYUPINPAI'" class="ps-list-embed">
              <brand v-if="project.id" :old-infos="editInfo" :isbj="false" :show-change-status="true" />
            </div>
          </div>

          <div class="ps-footer-bar">
            <div class="ps-footer-tip">
              💡 更新时系统自动复制最新已通过版本，只需修改<b>变动项</b>即可
            </div>
            <div class="ps-footer-actions">
              <button type="button" class="ps-btn ps-btn--white" @click="editPrev">← 上一步</button>
              <button type="button" class="ps-btn ps-btn--blue" @click="editNext">下一步 →</button>
              <button
                type="button"
                class="ps-btn ps-btn--blue"
                :disabled="saving"
                @click="submitAudit"
              >
                ✉ 提交变更审核
              </button>
            </div>
          </div>
        </div>
      </div>
    </a-spin>

    <div class="ps-modal-mask" :class="{ open: compareVisible }" @click.self="compareVisible = false">
      <div class="ps-modal">
        <div class="ps-modal-head">
          <div>
            <h3>版本对比</h3>
            <p>
              左：上一版本　右：变更后　<span style="color: #b91c1c">红＝删除</span>　<span
                style="color: #15803d"
                >绿＝新增</span
              >
            </p>
          </div>
          <button type="button" class="ps-close-btn" @click="compareVisible = false">✕</button>
        </div>
        <div class="ps-modal-body">
          <div class="ps-compare-grid">
            <div>
              <div class="ps-cmp-head gray">已通过版本</div>
              <div class="ps-cmp-body">
                <div v-for="(f, i) in compareFields" :key="'l' + i" class="ps-cmp-line">
                  <span class="k">{{ f.name }}：</span>
                  <span v-if="f.changed" class="diff-old">{{ f.old }}</span>
                  <span v-else>{{ f.old }}</span>
                </div>
                <div v-if="!compareFields.length" class="ps-cmp-line">（暂无变更字段）</div>
              </div>
            </div>
            <div>
              <div class="ps-cmp-head blue">变更后</div>
              <div class="ps-cmp-body blue-border">
                <div v-for="(f, i) in compareFields" :key="'r' + i" class="ps-cmp-line">
                  <span class="k">{{ f.name }}：</span>
                  <span v-if="f.changed" class="diff-new">{{ f.new }}</span>
                  <span v-else>{{ f.new }}</span>
                </div>
                <div v-if="!compareFields.length" class="ps-cmp-line">（暂无变更字段）</div>
              </div>
            </div>
          </div>
          <div v-if="compareFields.filter((f) => f.changed).length" class="ps-change-alert">
            ⚠ 检测到
            <b>{{ compareFields.filter((f) => f.changed).length }}</b>
            处变更：{{
              compareFields
                .filter((f) => f.changed)
                .map((f) => f.name)
                .join("、")
            }}。管理员将重点审核这些字段。
          </div>
        </div>
        <div class="ps-modal-foot">
          <button type="button" class="ps-btn ps-btn--white" @click="compareVisible = false">
            关闭
          </button>
        </div>
      </div>
    </div>

    <div
      class="ps-modal-mask"
      :class="{ open: submitPreviewVisible }"
      @click.self="closeSubmitPreview"
    >
      <div class="ps-modal ps-modal--preview">
        <div class="ps-modal-head">
          <div>
            <h3>确认本次提交</h3>
            <p>以下是本次将整批提交的变更，未改动的模块不会进入审核。</p>
          </div>
          <button type="button" class="ps-close-btn" @click="closeSubmitPreview">✕</button>
        </div>
        <div class="ps-modal-body">
          <div v-if="!submitPreviewGroups.length" class="ps-cmp-line">暂无待提交变更</div>
          <div v-for="group in submitPreviewGroups" :key="group.type" class="ps-preview-group">
            <div class="ps-preview-group__title">{{ group.title }}</div>
            <div v-for="(item, idx) in group.items" :key="item.id || idx" class="ps-preview-item">
              <div class="ps-preview-item__head">
                <span class="ps-preview-op" :class="'is-' + item.opKey">{{ item.opText }}</span>
                <span class="ps-preview-item__name">{{ item.rowTitle }}</span>
              </div>
              <div v-if="item.fields.length" class="ps-preview-fields">
                <div v-for="(f, fi) in item.fields" :key="f.key + fi" class="ps-preview-field">
                  <span class="k">{{ f.label }}</span>
                  <span v-if="item.opKey === 'INSERT'" class="diff-new">{{ f.after }}</span>
                  <template v-else-if="item.opKey === 'DELETE'">
                    <span class="diff-old">{{ f.before }}</span>
                  </template>
                  <template v-else>
                    <span class="diff-old">{{ f.before }}</span>
                    <span class="ps-preview-arrow">→</span>
                    <span class="diff-new">{{ f.after }}</span>
                  </template>
                </div>
              </div>
              <div v-else class="ps-preview-empty">（无字段明细，按整条记录提交）</div>
            </div>
          </div>
        </div>
        <div class="ps-modal-foot">
          <button type="button" class="ps-btn ps-btn--white" @click="closeSubmitPreview">
            返回修改
          </button>
          <button
            type="button"
            class="ps-btn ps-btn--blue"
            :disabled="submitLoading || !submitPreviewGroups.length"
            @click="confirmSubmitAudit"
          >
            确认整批提交
          </button>
        </div>
      </div>
    </div>

    <div class="preview-pop-box" v-if="showEvidenceBox">
      <div class="preview-boxs">
        <evidencelist
          :title="evidenceTitle"
          :dataid="applyId"
          :code="evidenceCode"
          :isEdit="baseLocked"
          :id="applyId"
          @closePreview="showEvidenceBox = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { getAction, postAction, putAction, fileUpdate } from "@/api/index";
import StatusBadge from "./StatusBadge.vue";
import evidencelist from "@/components/common/evidencelist";
import teamInfo from "@/components/szStudioFileupload/teamInfo.vue";
import teachAdd from "@/components/szStudioFileupload/teachingAndResearch.vue";
import budget from "@/components/szStudioFileupload/budget.vue";
import capitalExpenditure from "@/components/szStudioFileupload/capitalExpenditure.vue";
import scientificeAdd from "@/components/szStudioFileupload/scientificeAndResearch.vue";
import activityPlan from "@/components/szStudioFileupload/activityPlan.vue";
import resultMod from "@/components/szStudioFileupload/result.vue";
import activityMod from "@/components/szStudioFileupload/activity.vue";
import teamBuilding from "@/components/szStudioFileupload/teamBuilding.vue";
import practiceBase from "@/components/szStudioFileupload/practiceBase.vue";
import honor from "@/components/szStudioFileupload/honor.vue";
import brand from "@/components/szStudioFileupload/brand.vue";
import { AUDIT_TYPE_MAP, FIELD_LABELS } from "@/components/auditPage/data.js";
import { getDraftChangeList, getModulePendingAuditList } from "@/api/auditTask.js";

const SKIP_SIDE = { GZSJIDIHUODONG: 1 };
const MODULES = (AUDIT_TYPE_MAP[1] || [])
  .filter((m) => !SKIP_SIDE[m.id])
  .map((m) => ({
    key: m.id,
    label: m.title,
    taskType: m.id,
  }));

export default {
  name: "StudioUpdatePage",
  components: {
    StatusBadge,
    evidencelist,
    teamInfo,
    teachAdd,
    budget,
    capitalExpenditure,
    scientificeAdd,
    activityPlan,
    resultMod,
    activityMod,
    teamBuilding,
    practiceBase,
    honor,
    brand,
  },
  data() {
    return {
      locale,
      modules: MODULES,
      editStep: 0,
      pageLoading: false,
      saving: false,
      project: {},
      form: this.emptyForm(),
      originBase: {},
      fileList: [],
      planList: [],
      letterList: [],
      yearOpen: { applyYear: false },
      loadingDecl: false,
      loadingPlan: false,
      loadingLetter: false,
      baseTaskId: "",
      baseTaskState: "",
      pendingList: [],
      compareVisible: false,
      submitPreviewVisible: false,
      submitLoading: false,
      draftTasks: [],
      showEvidenceBox: false,
      evidenceTitle: "",
      evidenceCode: "",
    };
  },
  computed: {
    applyId() {
      return this.$route.query.id || "";
    },
    currentModule() {
      return this.modules[this.editStep] || this.modules[0];
    },
    currentKey() {
      return this.currentModule.key;
    },
    studioLabels() {
      return (FIELD_LABELS[1] && FIELD_LABELS[1].GZSJIBENXINXI) || {};
    },
    editInfo() {
      const p = this.project || {};
      return { ...p, id: p.id || this.applyId, auditState: "2" };
    },
    baseLocked() {
      return String(this.baseTaskState) === "1";
    },
    hasPendingList() {
      return (this.pendingList || []).some(
        (t) => t.taskType !== "GZSJIBENXINXI" && String(t.auditState) === "1"
      );
    },
    editingStatusText() {
      if (this.baseLocked || this.hasPendingList) return "含待审核变更";
      return "变更草稿";
    },
    baseChangeDiffs() {
      return this.buildStudioDiffs(false);
    },
    compareFields() {
      return this.buildStudioDiffs(true);
    },
    submitPreviewGroups() {
      const order = this.modules.map((m) => m.taskType);
      const titles = {};
      this.modules.forEach((m) => {
        titles[m.taskType] = m.label;
      });
      const grouped = {};
      (this.draftTasks || []).forEach((task) => {
        const type = task.taskType || "_";
        if (!grouped[type]) grouped[type] = [];
        grouped[type].push(this.buildPreviewItem(task));
      });
      const result = order
        .filter((t) => grouped[t] && grouped[t].length)
        .map((t) => ({ type: t, title: titles[t] || t, items: grouped[t] }));
      Object.keys(grouped).forEach((t) => {
        if (order.indexOf(t) >= 0) return;
        result.push({ type: t, title: titles[t] || t, items: grouped[t] });
      });
      return result;
    },
    moduleChangeMap() {
      const map = {};
      (this.pendingList || []).forEach((t) => {
        const s = String(t.auditState);
        // 基本信息模块的已驳回(3)不展示数量；其余模块草稿(0)、待审核(1)、已驳回(3)均计入
        if (t.taskType === "GZSJIBENXINXI") {
          if (s !== "0" && s !== "1") return;
        } else if (s !== "0" && s !== "1" && s !== "3") {
          return;
        }
        const type = t.taskType || "_";
        map[type] = (map[type] || 0) + 1;
      });
      return map;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    emptyForm() {
      return {
        name: "",
        applyYear: null,
        address: "",
        acreage: "",
        belongDepartment: "",
        foundTime: null,
        tsSzgzsKnow: undefined,
        tsSzgzsSatisfied: undefined,
        reportNum: undefined,
        conmunicateNum: undefined,
        studioStatus: true,
        declarationName: "",
        declarationPath: "",
        activityPlanName: "",
        activityPlanPath: "",
        letterOfCommitmentName: "",
        letterOfCommitmentPath: "",
      };
    },
    async init() {
      if (!this.applyId) {
        this.$message.error("缺少项目 ID");
        return;
      }
      this.pageLoading = true;
      try {
        await this.loadProject();
        await this.applyPendingChanges();
      } finally {
        this.pageLoading = false;
      }
    },
    loadProject() {
      return getAction("/lx/lxApply/queryById", { id: this.applyId }).then((res) => {
        if (res.code !== 200 && res.code !== 0) {
          this.$message.error(res.message || "加载项目失败");
          return;
        }
        const p = res.result || {};
        this.project = p;
        let live = p;
        if (p.changeContent) {
          try {
            live =
              typeof p.changeContent === "string" ? JSON.parse(p.changeContent) : p.changeContent;
          } catch (e) {
            live = p;
          }
        }
        this.applyBaseToForm(live, true);
        if (live !== p) this.applyBaseToForm(p, false);
      });
    },
    applyBaseToForm(p, setOrigin) {
      const statusOn = String(p.studioStatus) === "0" || p.studioStatus === true;
      this.form = {
        name: p.name || "",
        applyYear: p.applyYear ? moment(String(p.applyYear), "YYYY") : null,
        address: p.address || "",
        acreage: p.acreage == null ? "" : p.acreage,
        belongDepartment: p.belongDepartment || "",
        foundTime: p.foundTime ? moment(p.foundTime) : null,
        tsSzgzsKnow: p.tsSzgzsKnow,
        tsSzgzsSatisfied: p.tsSzgzsSatisfied,
        reportNum: p.reportNum,
        conmunicateNum: p.conmunicateNum,
        studioStatus: statusOn,
        declarationName: p.declarationName || "",
        declarationPath: p.declarationPath || "",
        activityPlanName: p.activityPlanName || "",
        activityPlanPath: p.activityPlanPath || "",
        letterOfCommitmentName: p.letterOfCommitmentName || "",
        letterOfCommitmentPath: p.letterOfCommitmentPath || "",
      };
      this.fileList = this.toFileList(p.declarationName, p.declarationPath);
      this.planList = this.toFileList(p.activityPlanName, p.activityPlanPath);
      this.letterList = this.toFileList(p.letterOfCommitmentName, p.letterOfCommitmentPath);
      if (setOrigin) {
        this.originBase = {
          name: p.name || "",
          applyYearText: this.formatYear(p.applyYear),
          address: p.address || "",
          acreage: p.acreage == null ? "" : String(p.acreage),
          belongDepartment: p.belongDepartment || "",
          foundTimeText: this.formatDate(p.foundTime),
          tsSzgzsKnow: p.tsSzgzsKnow,
          tsSzgzsSatisfied: p.tsSzgzsSatisfied,
          reportNum: p.reportNum,
          conmunicateNum: p.conmunicateNum,
          studioStatus: statusOn ? "0" : "1",
          declarationName: p.declarationName || "",
          activityPlanName: p.activityPlanName || "",
          letterOfCommitmentName: p.letterOfCommitmentName || "",
        };
      }
    },
    toFileList(name, path) {
      if (!name || !path) return [];
      return [{ uid: "1", name, status: "done", path }];
    },
    applyPendingChanges() {
      if (!this.applyId) return Promise.resolve();
      return getModulePendingAuditList({ applyId: this.applyId })
        .then((res) => {
          if (res.code !== 200 && res.code !== 0) return;
          const list = this.flattenPendingList(res.result);
          this.pendingList = list;
          const base = this.pickModuleTask(list, "GZSJIBENXINXI");
          if (base) {
            this.baseTaskId = base.id || "";
            this.baseTaskState = String(base.auditState || "");
            const after = this.parsePreviewJson(base.dataAfter || base.applicationData);
            if (after && Object.keys(after).length) {
              this.applyBaseToForm({ ...this.project, ...after }, false);
            }
          } else {
            this.baseTaskId = "";
            this.baseTaskState = "";
          }
        })
        .catch(() => {});
    },
    flattenPendingList(map) {
      const list = [];
      Object.keys(map || {}).forEach((key) => {
        (map[key] || []).forEach((item) => {
          list.push({ ...item, taskType: item.taskType || key });
        });
      });
      return list;
    },
    pickModuleTask(list, taskType) {
      const items = (list || []).filter((t) => t.taskType === taskType);
      return (
        items.find((t) => String(t.auditState) === "1") ||
        items.find((t) => String(t.auditState) === "0") ||
        // 已驳回(3)任务也接续原任务编辑，后端会重新打开为草稿，避免重复建任务
        items.find((t) => String(t.auditState) === "3") ||
        null
      );
    },
    // 刷新模块待提交/待审核任务，仅更新角标数据，不覆盖表单
    refreshPendingTasks() {
      if (!this.applyId) return Promise.resolve();
      return getModulePendingAuditList({ applyId: this.applyId })
        .then((res) => {
          if (res.code !== 200 && res.code !== 0) return;
          const list = this.flattenPendingList(res.result);
          this.pendingList = list;
          const base = this.pickModuleTask(list, "GZSJIBENXINXI");
          this.baseTaskId = base ? base.id || "" : "";
          this.baseTaskState = base ? String(base.auditState || "") : "";
        })
        .catch(() => {});
    },
    moduleCount(key) {
      return this.moduleChangeMap[key] || 0;
    },
    moduleChanged(key) {
      if (key === "GZSJIBENXINXI") {
        return this.baseChangeDiffs.length > 0 || this.moduleCount(key) > 0;
      }
      return this.moduleCount(key) > 0;
    },
    moduleTotal(key) {
      if (key === "GZSJIBENXINXI") {
        return Math.max(this.baseChangeDiffs.length, this.moduleCount(key));
      }
      return this.moduleCount(key);
    },
    modulePending(key) {
      return (this.pendingList || []).some(
        (t) => t.taskType === key && String(t.auditState) === "1"
      );
    },
    cancelPendingTask() {
      if (!this.baseTaskId) return;
      this.$confirm({
        title: "撤销待审核变更",
        content: "撤销后该条待审核变更会关闭，页面恢复为已通过内容，然后才能重新修改。",
        okText: "确认撤销",
        cancelText: "取消",
        onOk: () =>
          postAction(`/audit/lxAuditTask/cancelTask?ids=${this.baseTaskId}`).then((res) => {
            if (res.code === 200) {
              this.$message.success("已撤销，现在可以修改");
              return this.loadProject().then(() => this.applyPendingChanges());
            }
            this.$message.error(res.message || "撤销失败");
          }),
      });
    },
    formValue(key) {
      if (key === "applyYear") return this.formatYear(this.form.applyYear);
      if (key === "foundTime") return this.formatDate(this.form.foundTime);
      if (key === "studioStatus") return this.form.studioStatus ? "开" : "关";
      if (key === "tsSzgzsKnow" || key === "tsSzgzsSatisfied") {
        const v = this.form[key];
        if (v === null || v === undefined || v === "") return "";
        return /%$/.test(String(v)) ? String(v) : `${v}%`;
      }
      return this.form[key];
    },
    originValue(key) {
      if (key === "applyYear") return this.originBase.applyYearText;
      if (key === "foundTime") return this.originBase.foundTimeText;
      if (key === "studioStatus") {
        return String(this.originBase.studioStatus) === "0" ? "开" : "关";
      }
      if (key === "tsSzgzsKnow" || key === "tsSzgzsSatisfied") {
        const v = this.originBase[key];
        if (v === null || v === undefined || v === "") return "";
        return /%$/.test(String(v)) ? String(v) : `${v}%`;
      }
      return this.originBase[key];
    },
    buildStudioDiffs(keepUnchanged) {
      const labels = this.studioLabels;
      const list = [];
      Object.keys(labels).forEach((key) => {
        const name = labels[key];
        if (!name) return;
        const oldV = this.display(this.originValue(key));
        const newV = this.display(this.formValue(key));
        const changed = oldV !== newV;
        if (keepUnchanged || changed) {
          list.push({ key, name, old: oldV, new: newV, changed });
        }
      });
      return keepUnchanged ? list.filter((f) => f.changed) : list;
    },
    isBaseChanged(key) {
      return this.norm(this.originValue(key)) !== this.norm(this.formValue(key));
    },
    isFileChanged(key) {
      return this.isBaseChanged(key);
    },
    isBaseDirty() {
      return Object.keys(this.studioLabels).some((k) => this.isBaseChanged(k));
    },
    norm(v) {
      if (v === null || v === undefined || v === "null") return "";
      return String(v);
    },
    display(v) {
      const s = this.norm(v);
      return s === "" ? "-" : s;
    },
    formatYear(v) {
      if (!v) return "";
      if (typeof v === "string" && /^\d{4}/.test(v.trim())) return v.trim().slice(0, 4);
      const d = moment(v);
      return d.isValid() ? String(d.year()) : String(v);
    },
    formatDate(v) {
      if (!v) return "";
      const d = moment(v);
      return d.isValid() ? d.format("YYYY-MM-DD") : String(v);
    },
    onYearChange(key, value) {
      this.form[key] = value;
      this.yearOpen[key] = false;
    },
    editGo(i) {
      this.editStep = i;
      this.refreshPendingTasks();
    },
    goModule(key) {
      const i = this.modules.findIndex((m) => m.key === key);
      if (i >= 0) {
        this.editStep = i;
        this.refreshPendingTasks();
      }
    },
    editNext() {
      if (this.editStep < this.modules.length - 1) {
        this.editStep += 1;
        this.refreshPendingTasks();
      } else this.$message.info("已是最后一个模块");
    },
    editPrev() {
      if (this.editStep > 0) {
        this.editStep -= 1;
        this.refreshPendingTasks();
      } else this.$message.info("已是第一个模块");
    },
    goBack() {
      this.$router.push({
        name: "szStudioProjectDetail",
        query: {
          id: this.applyId,
          applyType: "1",
          name: this.project.name,
          tab: "current",
        },
      });
    },
    showEvidence(num) {
      if (num === 0) {
        this.evidenceTitle = "项目被省级或国家级媒体报道次数";
        this.evidenceCode = "xxbsjhgjjmtbdcs";
      } else {
        this.evidenceTitle = "省内外同类院校前来交流学习次数";
        this.evidenceCode = "snwtlyxqljlxxcs";
      }
      this.showEvidenceBox = true;
    },
    beforeUpload(file, kind) {
      if (this.baseLocked) {
        this.$message.warning("基本信息待审核中，请先撤销后再修改");
        return false;
      }
      const listKey = kind === "declaration" ? "fileList" : kind === "plan" ? "planList" : "letterList";
      if (this[listKey].length >= 1) {
        this.$message.error("只能上传一个文件,请移除后再上传");
        return false;
      }
      const loadKey =
        kind === "declaration" ? "loadingDecl" : kind === "plan" ? "loadingPlan" : "loadingLetter";
      this[loadKey] = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success("上传成功");
            this[listKey] = [{ uid: file.uid, name: file.name, status: "done", path: res.message }];
            if (kind === "declaration") {
              this.form.declarationName = file.name;
              this.form.declarationPath = res.message;
            } else if (kind === "plan") {
              this.form.activityPlanName = file.name;
              this.form.activityPlanPath = res.message;
            } else {
              this.form.letterOfCommitmentName = file.name;
              this.form.letterOfCommitmentPath = res.message;
            }
          } else {
            this.$message.error("上传失败");
          }
        })
        .finally(() => {
          this[loadKey] = false;
        });
      return false;
    },
    removeFile(kind) {
      if (kind === "declaration") {
        this.fileList = [];
        this.form.declarationName = "";
        this.form.declarationPath = "";
      } else if (kind === "plan") {
        this.planList = [];
        this.form.activityPlanName = "";
        this.form.activityPlanPath = "";
      } else {
        this.letterList = [];
        this.form.letterOfCommitmentName = "";
        this.form.letterOfCommitmentPath = "";
      }
    },
    validateBase() {
      if (!this.form.name) return "请填写工作室名称";
      if (!this.form.applyYear) return "请选择申报年份";
      if (!this.form.address) return "请填写工作室地点";
      if (!this.form.acreage) return "请填写思政教育工作室面积";
      if (!/^(0*[1-9]\d*\.?\d+|[1-9]\d*)$/.test(String(this.form.acreage))) {
        return "输入的思政教育工作室面积格式不正确";
      }
      if (!this.form.belongDepartment) return "请填写思政教育工作室所属部门";
      if (!this.form.foundTime) return "请选择工作室建设日期";
      if (!this.fileList.length && !this.form.declarationPath) return "请上传申报书";
      return "";
    },
    buildBaseParams() {
      return {
        applyType: "1",
        name: this.form.name,
        address: this.form.address,
        foundTime: this.formatDate(this.form.foundTime),
        applyYear: this.formatYear(this.form.applyYear),
        id: this.applyId,
        declarationName: this.form.declarationName,
        declarationPath: this.form.declarationPath,
        acreage: this.form.acreage,
        belongDepartment: this.form.belongDepartment,
        tsSzgzsKnow: this.form.tsSzgzsKnow,
        tsSzgzsSatisfied: this.form.tsSzgzsSatisfied,
        reportNum: this.form.reportNum,
        conmunicateNum: this.form.conmunicateNum,
        activityPlanName: this.form.activityPlanName || "",
        activityPlanPath: this.form.activityPlanPath || "",
        letterOfCommitmentName: this.form.letterOfCommitmentName || "",
        letterOfCommitmentPath: this.form.letterOfCommitmentPath || "",
        studioStatus: this.form.studioStatus ? "0" : "1",
      };
    },
    saveBase(silent) {
      if (this.baseLocked) {
        if (!silent) this.$message.warning("基本信息待审核中，请先撤销后再修改");
        return Promise.resolve();
      }
      const err = this.validateBase();
      if (err) {
        if (!silent) this.$message.info(err);
        return Promise.reject({ step: 0, message: err });
      }
      const params = this.buildBaseParams();
      const ok = (res) => {
        if (!silent) this.$message.success("保存成功");
        return res;
      };
      const fail = (res) => {
        this.$message.error((res && res.message) || "保存失败");
        return Promise.reject(res);
      };
      if (this.baseTaskId) {
        return putAction("/audit/lxAuditTask/editTaskAndDetail", {
          id: this.baseTaskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        }).then((res) => (res.code === 200 ? ok(res) : fail(res)));
      }
      return postAction("/lx/lxApply/szAdd", params).then((res) => {
        if (res.code === 200) {
          this.baseTaskId = (res.result && res.result.taskId) || "";
          return ok(res);
        }
        return fail(res);
      });
    },
    persistDirtyModules() {
      if (this.isBaseDirty() && !this.baseLocked) return this.saveBase(true);
      return Promise.resolve();
    },
    handlePersistError(err) {
      if (err && err.step != null) {
        this.editStep = err.step;
        this.$message.info(err.message || "请完善必填项后再提交");
        return;
      }
      if (err && err.message) this.$message.error(err.message);
    },
    saveDraft() {
      this.saving = true;
      return this.persistDirtyModules()
        .then(() => {
          this.$message.success("草稿已保存");
          this.refreshPendingTasks();
        })
        .catch((err) => this.handlePersistError(err))
        .finally(() => {
          this.saving = false;
        });
    },
    submitAudit() {
      this.saving = true;
      this.persistDirtyModules()
        .then(() => getDraftChangeList(this.applyId))
        .then((res) => {
          if (res.code !== 200) {
            this.$message.info(res.message || "获取变更清单失败");
            return;
          }
          const list = res.result || [];
          // 已驳回且为最新一轮的数据会随「提交变更」一并重新送审，纳入提交清单
          const rejectRows = (this.pendingList || []).filter(
            (t) => String(t.auditState) === "3"
          );
          if (!list.length && !rejectRows.length) {
            this.$message.info("没有待提交的变更");
            return;
          }
          this.draftTasks = list.concat(rejectRows);
          this.submitPreviewVisible = true;
        })
        .catch((err) => this.handlePersistError(err))
        .finally(() => {
          this.saving = false;
        });
    },
    closeSubmitPreview() {
      this.submitPreviewVisible = false;
    },
    confirmSubmitAudit() {
      if (this.submitLoading || !this.submitPreviewGroups.length) return;
      this.submitLoading = true;
      getAction("/audit/lxAuditTask/submit?applyId=" + this.applyId, {})
        .then((res) => {
          if (res.code === 200) {
            this.submitPreviewVisible = false;
            this.$message.success("已提交，等待学校或教育局整批审核");
            this.$router.push({
              name: "szStudioProjectDetail",
              query: {
                id: this.applyId,
                applyType: "1",
                name: this.project.name,
                tab: "requests",
              },
            });
          } else {
            this.$message.info(res.message || "提交失败");
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    parsePreviewJson(str) {
      if (!str) return {};
      let v = str;
      if (typeof v === "string") {
        try {
          v = JSON.parse(v);
        } catch (e) {
          return {};
        }
      }
      if (typeof v === "string") {
        try {
          v = JSON.parse(v);
        } catch (e) {
          return {};
        }
      }
      if (!v || typeof v !== "object" || Array.isArray(v)) return {};
      return v;
    },
    previewJsonHasFields(obj) {
      if (!obj || typeof obj !== "object") return false;
      return Object.keys(obj).some((k) => {
        const val = obj[k];
        return val !== null && val !== undefined && val !== "" && val !== "null";
      });
    },
    localDiffToFields(list) {
      return (list || []).map((f) => ({
        key: f.key || f.name,
        label: f.name,
        before: f.old,
        after: f.new,
      }));
    },
    displayPreviewVal(val, key, taskType) {
      if (val === null || val === undefined || val === "") return "-";
      const s = String(val).trim();
      if (
        key === "foundTime" ||
        key === "birthday" ||
        key === "lxsj" ||
        key === "jxsj" ||
        key === "bsTime" ||
        key === "cooperativeTime"
      ) {
        const d = moment(val);
        if (d.isValid()) return d.format("YYYY-MM-DD");
      }
      if (
        key === "applyYear" ||
        key === "vintages" ||
        key === "year" ||
        key === "acquireYear" ||
        key === "costYear" ||
        key === "activityYear" ||
        key === "joinYear"
      ) {
        return this.formatYear(val) || "-";
      }
      if (key === "studioStatus") {
        if (s === "开" || s === "0" || s === "true") return "开";
        if (s === "关" || s === "1" || s === "false") return "关";
      }
      if (
        key === "izResponse" ||
        key === "izDedicated" ||
        key === "izPolitical" ||
        key === "izBsxw"
      ) {
        if (s === "1" || s === "true" || s === "是") return "是";
        if (s === "0" || s === "false" || s === "否") return "否";
      }
      if (key === "sex") {
        if (s === "1") return "男";
        if (s === "2") return "女";
      }
      if (Array.isArray(val)) return val.filter(Boolean).join("、") || "-";
      return s;
    },
    buildPreviewItem(task) {
      const opKey = task.operation || "UPDATE";
      const opText = { INSERT: "新增", UPDATE: "修改", DELETE: "删除" }[opKey] || opKey;
      if (task.taskType === "GZSJIBENXINXI" && this.baseChangeDiffs.length) {
        return {
          id: task.id,
          opKey: opKey === "INSERT" || opKey === "DELETE" ? opKey : "UPDATE",
          opText,
          rowTitle: this.form.name || (this.project && this.project.name) || "工作室基本信息",
          fields: this.localDiffToFields(this.baseChangeDiffs),
        };
      }
      let before = this.parsePreviewJson(task.dataTransBefore);
      let after = this.parsePreviewJson(task.datTransAfter);
      if (!this.previewJsonHasFields(before)) before = this.parsePreviewJson(task.dataBefore);
      if (!this.previewJsonHasFields(after)) after = this.parsePreviewJson(task.dataAfter);
      const labels = (FIELD_LABELS[1] && FIELD_LABELS[1][task.taskType]) || {};
      const fields = [];
      Object.keys(labels).forEach((key) => {
        const label = labels[key];
        if (!label) return;
        let oldRaw = before[key];
        let newRaw = after[key];
        if (oldRaw == null || oldRaw === "") oldRaw = before[key + "_dictText"];
        if (newRaw == null || newRaw === "") newRaw = after[key + "_dictText"];
        if (key === "education" || key === "degree") {
          if (oldRaw == null || oldRaw === "") {
            oldRaw = before.education || before.degree || before.education_dictText;
          }
          if (newRaw == null || newRaw === "") {
            newRaw = after.education || after.degree || after.education_dictText;
          }
        }
        const b = this.displayPreviewVal(oldRaw, key, task.taskType);
        const a = this.displayPreviewVal(newRaw, key, task.taskType);
        if (opKey === "INSERT") {
          if (a !== "-") fields.push({ key, label, before: "-", after: a });
        } else if (opKey === "DELETE") {
          if (b !== "-") fields.push({ key, label, before: b, after: "-" });
        } else if (b !== a) {
          fields.push({ key, label, before: b, after: a });
        }
      });
      const src = opKey === "DELETE" ? before : after;
      const rowTitle =
        src.teacherName ||
        src.name ||
        src.title ||
        src.buildName ||
        src.baseName ||
        src.honorName ||
        src.brandName ||
        src.fileName ||
        src.xmmc ||
        "一条记录";
      return { id: task.id, opKey, opText, rowTitle, fields };
    },
    openCompare() {
      this.compareVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./updatePage.scss";
</style>
